// File: /var/www/tpcrm/frontend/src/services/agentWebsiteService.js
import api from './api';

const agentWebsiteService = {
  // Get agent's website configuration and available themes
  getConfig: async () => {
    const response = await api.get('/agent-websites/config');
    return response.data;
  },

  // Create or update website configuration
  updateConfig: async (configData) => {
    const response = await api.post('/agent-websites/config', configData);
    return response.data;
  },

  // Upload logo
  uploadLogo: async (logoFile) => {
    const formData = new FormData();
    formData.append('logo', logoFile);
    
    const response = await api.post('/agent-websites/logo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Get available content templates
  getTemplates: async () => {
    const response = await api.get('/agent-websites/templates');
    return response.data;
  },

  // Update content selection
  updateContent: async (selectedTemplates) => {
    const response = await api.post('/agent-websites/content', {
      selected_templates: selectedTemplates
    });
    return response.data;
  },

  // Get public website URL
  getPublicUrl: (subdomain) => {
    return `https://${subdomain}.tpcrm.io`;
  },

  // Get preview URL (for testing)
  getPreviewUrl: (subdomain) => {
    return `https://tpcrm.io/api/public-website/render/${subdomain}`;
  },

  // Get available website categories and agent's selections
  getCategories: async () => {
    const response = await api.get('/agent-websites/categories');
    return response.data;
  },

  // Update agent's selected categories
  updateCategories: async (categoriesData) => {
    const response = await api.post('/agent-websites/categories', categoriesData);
    return response.data;
  },

  // Get agent's offers and subcategories
  getOffers: async () => {
    const response = await api.get('/agent-websites/offers');
    return response.data;
  },

  // Create new offer
  createOffer: async (offerData) => {
    const response = await api.post('/agent-websites/offers', offerData);
    return response.data;
  },

  // Update existing offer
  updateOffer: async (offerId, offerData) => {
    const response = await api.put(`/agent-websites/offers/${offerId}`, offerData);
    return response.data;
  },

  // Delete offer
  deleteOffer: async (offerId) => {
    const response = await api.delete(`/agent-websites/offers/${offerId}`);
    return response.data;
  },

  // Get subcategories for a category
  getSubcategories: async (categoryId) => {
    const response = await api.get(`/agent-websites/subcategories/${categoryId}`);
    return response.data;
  },

  // Services management methods
  getServices: async () => {
    const response = await api.get('/agent-websites/services');
    return response.data;
  },

  createService: async (serviceData) => {
    const response = await api.post('/agent-websites/services', serviceData);
    return response.data;
  },

  updateService: async (serviceId, serviceData) => {
    const response = await api.put(`/agent-websites/services/${serviceId}`, serviceData);
    return response.data;
  },

  deleteService: async (serviceId) => {
    const response = await api.delete(`/agent-websites/services/${serviceId}`);
    return response.data;
  },

  updateServicesDescription: async (servicesDescription) => {
    const response = await api.put('/agent-websites/services/description', { servicesDescription });
    return response.data;
  },

  reorderServices: async (serviceIds) => {
    const response = await api.put('/agent-websites/services/reorder', { serviceIds });
    return response.data;
  }
};

export default agentWebsiteService;